
// ============================================
// モーダル
// ============================================
const modal = () => {
	// ----------------------------
	// 共通変数
	// ----------------------------
	//bodyタグ
	const body = document.body;
	const bodyClassList = body.classList;
	//modal
	const commonName = 'data-modal';
	const modalTarget = `${commonName}-target`;
	const modalTrigger = `${commonName}-trigger`;
	const modalCloseTrigger = `${commonName}-close`;
	const modalContent = `${commonName}-content`;
	//modal・アニメーション
	const modalActive = `${commonName}-active`;
	const modalAnimation = `${commonName}-animation`;
	const modalAnimationTrigger = `${commonName}-animationTrigger`;
	//クラス名
	const openClass = 'is-modal-open';
	const bodyFixedClass = 'is-contents-fixed';
	// ----------------------------
	// 共通関数
	// ----------------------------
	//モーダル共通処理
	const modalVisible = function (targetElement, isOpen) {
		if (!targetElement) return; // 要素がなければスルー

		if (isOpen) {
			targetElement.classList.add(openClass);
			return; // isOpenの場合はスルー
		}

		if (targetElement.getAttribute(modalAnimation)) {
			// CSSアニメーションを実行する要素を取得
			const wrap = targetElement.querySelector(`[${modalAnimationTrigger}]`);
			//アニメーションを実行
			if (wrap) {
				wrap.addEventListener('animationend', function handleClose() {
					targetElement.classList.remove(openClass); // 表示用クラスを削除
					wrap.removeEventListener('animationend', handleClose); // 一度だけ実行になるようイベントリスナーを削除
				});
			} else {
				targetElement.classList.remove(openClass); // 表示用クラスを削除
			}
		} else {
			//アニメーションがない場合はそのまま実行
			targetElement.classList.remove(openClass); // 表示用クラスを削除
		}
	};

	//背景固定処理
	function handleTouchMove(event) {
		//クリック要素がモーダルの子要素だった場合はスルー
		if (event.target.getAttribute(modalContent) || event.target.closest(`[${modalContent}]`)) return;
		//モーダル外ならスクロール防止
		event.preventDefault();
	}

	//モーダルを開く
	const openModal = function (triggerElement) {
		if (!triggerElement) return; //各要素がなければスルー
		//既に他のモーダルが開いている場合
		const currentModal = document.querySelector(`.${openClass}`);
		if (currentModal) {
			currentModal.setAttribute(modalActive, 'false'); // アクティブ属性をfalseに更新
			// モーダルの処理
			modalVisible(currentModal, true);
		}

		//クリックしたトリガーとdata属性の値が一致したターゲットを取得
		const triggerValue = triggerElement.getAttribute(modalTrigger);
		const target = body.querySelector(`[${modalTarget}="${triggerValue}"]`);
		if (!target) return; //要素がなければスルー

		target.setAttribute(modalActive, 'true'); // アクティブ属性をtrueに更新
		target.classList.toggle(openClass); // 表示用クラスを削除
		bodyClassList.add(bodyFixedClass); // 背景固定も解除

		//スクロール防止
		document.addEventListener('touchmove', handleTouchMove, {
			passive: false,
		});
	};

	//モーダルを閉じる
	const closeModal = function (triggerElement, clickedElement) {
		if (!triggerElement) return; //各要素がなければスルー

		//対象のモーダル要素を取得
		const target = triggerElement.closest(`[${modalTarget}]`);

		if (!target) return; //一致するコンテンツがなければスルー

		// モーダルコンテンツ内なら閉じない
		if (clickedElement.closest(`[${modalContent}]`)) return;

		// アクティブ属性をfalseに更新
		target.setAttribute(modalActive, 'false');
		modalVisible(target, false); // モーダルの処理
		bodyClassList.remove(bodyFixedClass); // 背景固定も解除

		//スクロール防止を解除
		document.removeEventListener('touchmove', handleTouchMove);
	};

	// ----------------------------
	// 処理
	// ----------------------------
	// wpギャラリーブロック対応のため、returnを削除
	// const triggers = document.querySelectorAll(`[${modalTrigger}]`);
	// if (!triggers.length) return; //モーダル要素がなければスルー

	document.addEventListener('click', function (event) {

		const trigger = event.target.closest(
			`[${modalTrigger}]`
		);
		//モーダルを開く処理
		if (trigger) {
			event.preventDefault();
			openModal(trigger);
		}

		//モーダルを閉じる処理
		const closeTrigger = event.target.closest(`[${modalCloseTrigger}]`);

		if (closeTrigger) {
			closeModal(closeTrigger, event.target);
		}
	});
};

export default modal;